
/*
 *
 * Date: 2025
 * Description: List card component for detailing items in a list
 * Author: Philippe Leroux @SKITSC
 *
 */

//Modules
import { Box, Typography , Grid } from "@mui/material"

//Interfaces
import { i_parts } from "../../interfaces/items.interface"
import { i_list_card, i_part_card_props } from "../../interfaces/display.interfaces"

//Components
import UserPartCard from "./user.part.card";
import { default_search } from "../../utils/constant";

const ListCard = ( props : i_list_card ) => {
    const part_props : i_part_card_props = {
        callback : () => {},
        addPart : () => {},
        path : props.path,
        type : 'view'
    }
    const countTotal = () => {
        return props.list.items.reduce((acc, curr) => acc + Number(curr.price), 0)
    }
    return (
        <Box sx={{ width : '100%' ,}}>
            <Box sx={{ border : '1px solid #EAECF0' , padding : 1 , maxWidth : '1200px' , marginLeft : 'auto' , marginRight : 'auto' }}>
                <Grid container>
                    <Grid size={4}  sx={{ alignContent : 'center'}}>
                        <Typography sx={{ textAlign : 'center' }}>
                            { "Your cart"}
                        </Typography>
                    </Grid>
                    <Grid size={4} sx={{ alignContent : 'center'}}>
                        <Typography>
                            {props.list.description}
                        </Typography>
                    </Grid>
                    <Grid size={2} sx={{ alignContent : 'center'}}>
                        <Typography>
                            {props.list.items.length} items
                        </Typography>
                    </Grid>                        
                        <Grid size={2}>
                            <Typography sx={{ fontSize : 14, fontWeight : 800}}>Total : {countTotal()}$ +Tx</Typography>
                        </Grid>
                </Grid>
            </Box>
             <Box sx={{ maxWidth : '1200px' , marginLeft : 'auto' , marginRight : 'auto' }}>
                    {props.list.items.map((item : i_parts , index : number) => (
                        <Box key={index}>
                            <UserPartCard in={false} rendering={false} part={item} filter={default_search} {...part_props}/>
                        </Box>
                    ))}
            </Box>
        </Box>
    )
}

export default ListCard;